module.exports = __webpack_public_path__ + "img/4-3@2x.0a189e67.png";